import type { Map as MapType } from "maplibre-gl";
import { createSiloMarker } from "./silos";
import type { PlatformType } from "../types"; // Using your PlatformType configuration: "ship" | "helicopter" | "truck"

const SILO_CATEGORIES: PlatformType[] = ["ship", "helicopter", "truck"];

// 🌟 VARIANT MATRIX: Matches selection combinations for rapid GPU lookup
const SELECTION_STATES = ["deselected", "selected"];

export async function registerSiloSprites(map: MapType): Promise<void> {
  const loadPromises: Promise<void>[] = [];

  for (const category of SILO_CATEGORIES) {
    // Generate both states upfront to prevent CPU execution while panning/zooming
    for (const state of SELECTION_STATES) {
      const isSelected = state === "selected";
      const spriteKey = `${category}-${state}`;

      const promise = new Promise<void>((resolve) => {
        let svgString = createSiloMarker(category, isSelected).trim();

        // 🛠️ FIX: Clean up lookups to match the actual raw template viewbox properties (154px)
        svgString = svgString
          .replace(/width="154"/g, 'width="128"')
          .replace(/height="154"/g, 'height="128"');

        if (!svgString.includes("xmlns=")) {
          svgString = svgString.replace(
            "<svg",
            '<svg xmlns="http://www.w3.org/2000/svg"',
          );
        }

        const blob = new Blob([svgString], {
          type: "image/svg+xml;charset=utf-8",
        });
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.width = 128;
        img.height = 128;

        img.onload = () => {
          // 1. Register the base category if it doesn't exist ("ship")
          // 🌟 FIX: "sdf: false" ensures MapLibre uses our custom amber gradients and outline filters!
          if (state === "deselected" && !map.hasImage(category)) {
            map.addImage(category, img, { sdf: false });
          }

          // 2. 🌟 SYSTEM PRE-MATCH: Register lookup combination (e.g., "ship-selected")
          if (!map.hasImage(spriteKey)) {
            map.addImage(spriteKey, img, { sdf: false });
          }

          URL.revokeObjectURL(url);
          resolve();
        };

        img.onerror = (err) => {
          console.error(
            `[Silo Sprite Engine] Error building hardware texture asset: ${spriteKey}`,
            err,
          );
          URL.revokeObjectURL(url);
          resolve();
        };

        img.src = url;
      });

      loadPromises.push(promise);
    }
  }

  await Promise.all(loadPromises);
  console.log(
    `🛰️ [GameEngine Sprite Manager] Pre-rendered all platform silo variants into WebGL texture pipeline!`,
  );
}
